import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BancaViewComponent } from './banca-view/banca-view.component';
import { BancheComboComponent } from './banche-combo/banche-combo.component';
import { FormsModule } from '@angular/forms';
import { MyCustomMaterialModule } from 'san-common';



@NgModule({
  declarations: [BancaViewComponent,BancheComboComponent
  ],exports:[
    BancaViewComponent,BancheComboComponent
  ],
  imports: [
    CommonModule,
    MyCustomMaterialModule,FormsModule
  ]
})
export class BancheSharedModule { }
